import React from "react";
import BackofficeLayout from "./BackofficeLayout";

const BackofficeIndex = () => {
  return (
    <BackofficeLayout>
      <div className="flex justify-center items-center min-h-[400px] p-6">
        <div className="bg-white dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-lg shadow-sm w-full h-[calc(100vh-150px)]">
          <div className="text-center h-full flex flex-col justify-center items-center">
            <h1 className="text-4xl font-bold mb-4 dark:text-neutral-100">Uptime - Backoffice</h1>
            <p className="text-gray-600 dark:text-neutral-400">
              Selecione uma opção no menu acima para gerenciar consultores ou falhas.
            </p>
          </div>
        </div>
      </div>
    </BackofficeLayout>
  );
};

export default BackofficeIndex;
